import { render, staticRenderFns } from "./ModalEditUrlTransparencia.vue?vue&type=template&id=4a89fa1c"
import script from "./ModalEditUrlTransparencia.vue?vue&type=script&lang=ts"
export * from "./ModalEditUrlTransparencia.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports